<template>
  <div id="app">
      <app-header></app-header>
            <!-- <transition
            name="fade"
            mode="out-in"
          > -->
            <router-view/>
          <!-- </transition> -->
      <app-footer></app-footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'



export default {
  name: 'App',
  components: {
    appHeader : Header,
    appFooter : Footer
  }

}
</script>

<style>


.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;

}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue